import { render, staticRenderFns } from "./DocumentPlaceholderCard.vue?vue&type=template&id=7a9dca38&scoped=true"
import script from "./DocumentPlaceholderCard.vue?vue&type=script&lang=js"
export * from "./DocumentPlaceholderCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentPlaceholderCard.vue?vue&type=style&index=0&id=7a9dca38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9dca38",
  null
  
)

export default component.exports